import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
export const defaultFeatureFlags = {
  replaceCategoriesOnAppTilesWithVendorName: false,
  hideInstallDownloadCountsEnabled: false,
  showAppRequestPlaceholder: false,
  enableNewAndNoteworthyApps: false,
  sortingLogicForCategoryFilter: 'default',
  enableRequestAppCtaCopyChange: false,
  enableBugBountyProgram: false,
  enableTrialExpiryBanner: false,
  enableCloudFortifiedAppsDiscovery: false,
  enableWebpImage: false,
  showCustomBackendErrorsFromUpm: false,
  enableFreeStarterTierFilter: false,
  fetchBugBountyStatusFromBackend: false,
  disableAppInstall: false,
  showManageAppRequestAlternativeLayout: false,
  spaRoutingForPartnerApps: false,
  spaRoutingForPartnerDetails: false,
  spaRoutingForPartnerPayment: false,
  disableAllHostingFromPromotionsDropdown: false,
  spaRoutingForPartnerReports: false,
  reviewsCompliancePrompt: false,
  displayAuditTabInManagePartnerPage: true,
  useAmktFrontendAthreosManagePartners: false,
  enableUpdateByCatalogServiceCall: false,
  enableThirtyFiveKPricingTiers: false,
  enableInContextAppRequest: false,
  showCompatibleSiteProducts: false,
  enableInProductHelpPartnerReporting: false,
  strideHipchatBanners: false,
  showTrustSignalsInManageAppRequests: false,
  showDatePickerOnManagePricingTab: false,
  enableLogAccessByDefaultMessage: false,
  showBenchmarkingUiDropdown: false,
  showDecomposedReviews: false,
  showQualtricsSurvey: false,
  enableRetryForLicenseDetailsPostInstallation: false,
  enableEmailSubscription: false,
  allowSectionMessageForPartnersForMigrationToCcp: [],
  enableIncludePartnerForAllowSectionMessageForMigrationToCcp: false,
  enableSwitchAccountInMenu: false,
  showAppListingTrustTab: false,
  displayPrivacyAndSecurityPreviewTab: false,
  enableReactivateForgeAppFromEmcee: false,
  enableGoogleAnalytics4Tracking: false,
  enableUserSessionAuthForMpacToEmceeRedirect: false,
  enableNewPartnerContactRole: false,
  showCopyChangesForPartnerContact: false,
  enableDualLicenseToggleInPartnersTable: false,
  enableReviewComplianceUi: false,
  enablePrefixCodeSectionForGenericCloudPromotions: false,
  enableBacRedirectionForCcpPromotions: false,
  allowPromotionMigrationBanner: false,
  enableMpacServerEolWarning: false,
  enableReportsV2FeedbackCollector: false
};
const FeatureFlags = /*#__PURE__*/React.createContext(defaultFeatureFlags);

/**
 * Note: Flag name from LaunchDarkly will be transformed using
 * lodash camel-case function, remember to cross check
 * @example enableMPACServerEOL -> enableMpacServerEol
 * @returns FeatureFlag values object
 */
export function useFeatureFlags() {
  return useContext(FeatureFlags);
}
export function withFeatureFlags(WrappedComponent) {
  return function FeatureFlagsHOC(props) {
    return /*#__PURE__*/React.createElement(FeatureFlags.Consumer, null, featureFlags => {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, featureFlags, props));
    });
  };
}
export default FeatureFlags;